Vue.component('przewodniki', {
	template: '#przewodniki',
	props: {
		country: { default: '' },
		region: { default: '' },
		city: { default: '' },
	},
	data: function () {
		return {
			menu: {},
			contentLoading: 1,
			contentFound: 1,
			content: "",
			index: null,
			imageMain: "",
			images: [],
			breadcrumbs: [],
			breadcrumbNow: ''
		}
	},
	created: function () {
		this.changeTitleAndDescription();
		this.getMenu();
		this.getContent();
		document.body.scrollTop = document.documentElement.scrollTop = 0;
	},
	methods: {
			changeTitleAndDescription: function () {
				const self = this;
				// title
				let newTitle = '';
				newTitle += 'Przewodnik po';
				if (self.city && self.city != 'default') newTitle += " mieście "+ self.titleCase(self.city) +" w";
				if (self.region && self.region != 'default') newTitle += " regionie "+ self.titleCase(self.region) +" w";
				if (self.country && self.country != 'default') newTitle += " kraju "+ self.titleCase(self.country); 
				
				newTitle += mainMetaTitleStatic;
				setPageTitle(newTitle);
				// meta description
				let newDescription = '';
				newDescription += 'Przewodnik po';
				if (self.city && self.city != 'default') newDescription += " mieście "+ self.titleCase(self.city) +" w";
				if (self.region && self.region != 'default') newDescription += " regionie "+ self.titleCase(self.region) +" w";
				if (self.country && self.country != 'default') newDescription += " kraju "+ self.titleCase(self.country); 
				newDescription += " - kraj, regiony, miasta -"+ mainMetaDecriptionStatic;
				setMeta("description", newDescription);
		},
		getMenu: function () {
			const self = this;
			$.post("/back/Przewodniki.php", { action: 'menu' }, function (result, textStatus) {
				if (result !== null) {
					self.menu = result;
				}
				serverBus.$emit('loading_end');
			}, "json");
		},
		getContent: function () {
			const self = this;

			if (self.country != '') {
				if (typeof respPrzewodniki !== 'undefined' && respPrzewodniki) {
					// console.log('[cURL] /back/Przewodniki.php');

					const result = respPrzewodniki;
					respPrzewodniki = '';

					self.getContentCallback(result);

				} else {
					// console.log('[Fetch/XHR] /back/Przewodniki.php');

					$.post(
						"/back/Przewodniki.php", 
						{ 
							action: 'content', 
							country: self.country, 
							region: self.region, 
							city: self.city 
						},
						function (result, textStatus) {
							self.getContentCallback(result);
						}, 
						"json"
					);
				}
      } else {
				self.breadcrumbNow = 'Przewodniki';
				self.contentFound = 1;
				self.contentLoading = 0;
			}
		},
		getContentCallback: function (result) {
			const self = this;

			if (result.found !== null) {
				self.contentFound = result.found;
			}
			if (result.description !== null) {
				self.content = result.description.split("<br \/>").join("<br>");
			}
			if (result.images === null) {
				self.images = [];
			} else {
				self.images = result.images;
			}
			if (result.imageMain !== null) {
				self.imageMain = result.imageMain;
			}

			if(self.contentFound == 0) {
				let newCanonicalTag = 'https://' +location.host;
				if (self.content) newCanonicalTag += location.pathname.substring(0, location.pathname.lastIndexOf("/"));
				else newCanonicalTag += '/przewodniki';
				setCanonicalTag(newCanonicalTag);
			}
			self.breadcrumbs.push({ text:'Przewodniki', routeName:'przewodniki'});
			result.breadcrumbs.forEach(function (breadcrumb, idx, array) {
				if (idx !== array.length - 1) {
					if (idx == 0) self.breadcrumbs.push({ text: breadcrumb, routeName: 'przewodniki', params: { country: self.country } });
					else if (idx == 1) self.breadcrumbs.push({ text: breadcrumb, routeName: 'przewodniki', params: { country: self.country, region: self.region } });
				} else {
					self.breadcrumbNow = breadcrumb;
				}
			});

			self.contentLoading = 0;
			serverBus.$emit('loading_end');
		},
		noPl: function (string) {
			const accents = "ÀÁÂÃÄÅĄĀāàáâãäåąßÒÓÔÕÕÖØŐòóôőõöøĎďDŽdžÈÉÊËĘèéêëęðÇçČčĆćÐÌÍÎÏĪìíîïīÙÚÛÜŰùűúûüĽĹŁľĺłÑŇŃňñńŔŕŠŚŞšśşŤťŸÝÿýŽŻŹžżźđĢĞģğ";
			const accentsOut = "AAAAAAAAaaaaaaaasOOOOOOOOoooooooDdDZdzEEEEEeeeeeeCcCcCcDIIIIIiiiiiUUUUUuuuuuLLLlllNNNnnnRrSSSsssTtYYyyZZZzzzdGGgg";

			let stringReturn = string.split("").map(function (letter, index) {
				let accentIndex = accents.indexOf(letter);
				return accentIndex !== -1 ? accentsOut[accentIndex] : letter;
			}).join("");

			return stringReturn;
		},
		forUrl: function (string) {
			return this.noPl(string).toLowerCase().replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/\ ]/gi, '-').replace(/-+/g, "-");
		},
		titleCase: function (str) {
				str = str.toLowerCase().split(' ');
				let final = [ ];
			
				str.forEach( function(word) {
					final.push(word.charAt(0).toUpperCase()+ word.slice(1));
				});
		 
			 return final.join(' ')
		}
	}
});
